import { createContext, useContext, useState } from "react";

interface SidebarContextValue {
  collapsed: boolean;
  setCollapsed: (v: boolean) => void;
  hoverExpanded: boolean;
  setExpandByHover: (v: boolean) => void;
  collapsedByBtn: boolean;
  setCollapsedByBtn: (v: boolean) => void;
}

const SidebarContext = createContext<SidebarContextValue>({
  collapsed: false,
  setCollapsed: () => { },
  hoverExpanded: false,
  setExpandByHover: () => { },
  collapsedByBtn: false,
  setCollapsedByBtn: () => { },
});

export function SidebarProvider({ children }: { children: React.ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);
  const [collapsedByBtn, setCollapsedByBtn] = useState(false);
  const [hoverExpanded, setExpandByHover] = useState(false);

  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed, hoverExpanded, setExpandByHover, collapsedByBtn, setCollapsedByBtn }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  return useContext(SidebarContext);
}
